import umbraco from '~/lib/api/umbraco';
import { TranslationsTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/umbraco/utils';

export default function getTranslations(signal: AbortSignal | undefined, locale?: string) {
    const url = getUrl('/content/translations');

    if (locale) {
        url.searchParams.set('culture', locale);
    }

    return umbraco.get(url, { signal }).json<Translations>();
}

type Translations = {
    [key in TranslationsTypes.TranslationKey]: string;
};
